// frontend/src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Router from './router';
import { ThemeProvider } from './context/ThemeContext';

const rootElement = document.getElementById('root') as HTMLElement;

document.documentElement.classList.remove('auth-hint');

// Always use createRoot (not hydrateRoot). The prerendered HTML serves SEO
// purposes for crawlers; React replaces it with a fresh render on load.
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <Router />
    </ThemeProvider>
  </React.StrictMode>
);
